module.exports = __webpack_public_path__ + "static/media/safe.114727be.png";